import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { DEFAULT_COLOR_PRESETS } from "../../_components/details/constants";
import { StyledColorPickerPopover } from "../../_components/styled/details/stylesTextPanel";
import { SketchPicker } from "react-color";
import { useSelector, useDispatch } from "react-redux";
import {
  Menu,
  MenuButton,
  Tooltip,
  MenuList,
  Box,
  Flex,
  Icon,
  Center,
  Spinner,
} from "@chakra-ui/react";
import { FaTimes } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { isEmpty, findIndex } from "lodash";
import { fetchBrandkitById, switchBrandkit, updateColorPalette } from "../../_actions/brandKitActions";
import axios from "axios";

const MenuButtonStyles = (color) => {
  return {
    _hover: {
      cursor: "pointer",
    },
    _disabled: {
      backgroundColor: color,
    },
    backgroundColor: color,
    height: "60px",
    width: "60px",
    borderRadius: "8px",
  };
};

const deleteColorButtonStyles = {
  height: "20px",
  width: "20px",
  borderRadius: "50%",
  backgroundColor: "#c4c4c4",
  border: "2px solid black",
  position: "absolute",
  top: "-5px",
  right: "-5px",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
};

const BrandkitPalettes = (props) => {
  const signal = axios.CancelToken.source();

  const { brandKit, palette, color } = props;

  const [isHovering, setIsHovering] = useState(false);
  const [inProgress, setInProgress] = useState(false);
  const [updatedColor, setUpdatedColor] = useState(color.rgb);

  const dispatch = useDispatch();
  const { t } = useTranslation(["studio"]);

  const workspacePermissionChecks = useSelector(state => state.permissions.workspacePermissionChecks);
  const { canDeleteBrandKitColorPalette, canEditBrandKitColorPalette } =
    workspacePermissionChecks;

  function handleMouseEnter() {
    setIsHovering(true);
  };

  function handleMouseLeave() {
    setIsHovering(false);
  }

  function getColorIndex(paletteArray) {
    var index = findIndex(paletteArray, (o) => {
      return o.rgb === color.rgb;
    });

    return index;
  };

  function updateColor({ rgb, hex }) {
    var paletteArray = palette.colors;
    var colorIndex = getColorIndex(paletteArray);

    if (colorIndex > -1) {
      paletteArray[colorIndex] = {
        ...color,
        rgb: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})`,
      };
    }

    dispatch(
      updateColorPalette(
        brandKit.id,
        palette.id,
        { colors: paletteArray },
        signal
      )
    )
      .then(() => {
        dispatch(
          fetchBrandkitById(brandKit.id)
        ).then((responseData) => dispatch(switchBrandkit(responseData)));
      });
  };

  function deleteColor() {
    setInProgress(true);
    var paletteArray = palette.colors;
    var colorIndex = getColorIndex(paletteArray);

    if (colorIndex > -1) {
      paletteArray = paletteArray.filter(
        (c, index) => colorIndex !== index
      );
    }

    dispatch(
      updateColorPalette(
        brandKit.id,
        palette.id,
        { colors: paletteArray },
        signal
      ))
      .then(() => {
        setInProgress(false);
        // TODO: fetch brandkit by id and switch to that brandkit
        dispatch(
          fetchBrandkitById(brandKit.id)
        ).then((responseData) => dispatch(switchBrandkit(responseData)))
      })
      .catch((err) => {
        setInProgress(false);
      });
  };

  return (
    <Flex
      direction="row"
      align="center"
      justify="center"
      color={color.rgb}
    >
      {!isEmpty(color) && (
        <Menu isLazy>
          <Tooltip hasArrow placement="bottom" label={color.rgb}>
            <div
              style={{ position: "relative" }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <MenuButton
                as={Box}
                sx={MenuButtonStyles(color.rgb)}
                disabled={!canEditBrandKitColorPalette}
              >
                {inProgress ? (
                  <Center
                    h='100%'
                    w='100%'
                    bg="brand.overlayDark"
                    borderRadius="8px"
                  >
                    <Spinner size="sm" color="primary.400" />
                  </Center>
                ) : null}
              </MenuButton>

              {isHovering && canDeleteBrandKitColorPalette && (
                <Tooltip hasArrow placement="top" label={t("delete_color")}>
                  <Box
                    as="button"
                    sx={deleteColorButtonStyles}
                    onClick={deleteColor}
                  >
                    <Icon as={FaTimes} fontSize="12px" color="black" />
                  </Box>
                </Tooltip>
              )}
            </div>
          </Tooltip>

          <MenuList>
            <StyledColorPickerPopover showBrandkitPaletteColors={false}>
              <SketchPicker
                disableAlpha={true}
                presetColors={DEFAULT_COLOR_PRESETS}
                color={updatedColor}
                onChange={({ rgb, hex }) => setUpdatedColor(`rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})`)}
                onChangeComplete={updateColor}
              />
            </StyledColorPickerPopover>
          </MenuList>
        </Menu>
      )}
    </Flex>
  );
};

BrandkitPalettes.propTypes = {};

BrandkitPalettes.defaultProps = {};

export default BrandkitPalettes;
